import { GridItemProps } from './GridItem/grid-item.types';
import { MLBTheme } from '../../style/theme.types';
import DefaultProps from '../../commonTypes/defaultprops.types';

// Ways to use justify-content
export enum GridAlignTypes {
  FLEX_START = 'flex-start',
  FLEX_END = 'flex-end',
  CENTER = 'center',
  SPACE_BETWEEN = 'space-between',
  SPACE_AROUND = 'space-around',
  SPACE_EVENLY = 'space-evenly'
}

export interface GridProps extends DefaultProps {
  verticalGutter?: number,
  horizontalGutter?: number,
  hasBorderGutter?: boolean,
  justifyContent?: GridAlignTypes,
  data?: Array<GridItemProps>
  theme?: MLBTheme
}
